const MenuMobile = {
  menu_mobile: document.querySelector('[data-mobile]'),
  menu_overlay: document.querySelector('[data-mobile-close]'),
  open: function () {
    const opens = document.querySelectorAll('[data-mobile-open]');

    if (opens.length > 0) opens.forEach(open => {
      open.addEventListener('click', () => {
        this.menu_mobile.classList.add('-active');
        this.menu_overlay.classList.add('-active');
      });
    });
  },
  close: function () {
    const close = document.querySelector('[data-mobile-close]');

    if (close) close.addEventListener('click', () => {
      this.menu_mobile.classList.remove('-active');
      this.menu_overlay.classList.remove('-active');
    });
  },
  submenus: function () {
    const _this = this;

    const submenus = document.querySelectorAll('[data-mobile] .has-submenu');
    if (submenus.length > 0) submenus.forEach(submenu => {
      submenu.addEventListener('click', (e) => {
        if (e.target.localName != 'span') {
          e.preventDefault();
  
          _this.menu_mobile.classList.add('-opening');
          _this.menu_overlay.classList.add('-opening');
  
          let dropdown = submenu.nextElementSibling;
          let submenu_active = submenu.parentElement.querySelector('.has-submenu.-active');
          let delay = 400;
    
          if(submenu.classList.contains('-active')){
            submenu.classList.remove('-active');
    
            // fix parent height
            if (submenu.parentElement.classList.contains('-active')) {
              if (submenu.parentElement.parentElement.classList.contains('-active')) {
                submenu.parentElement.parentElement.style.height = `${submenu.parentElement.parentElement.scrollHeight - dropdown.scrollHeight}px`;
                submenu.parentElement.style.height = `${submenu.parentElement.scrollHeight - dropdown.scrollHeight}px`;
              } else {
                submenu.parentElement.style.height = `${submenu.parentElement.scrollHeight - dropdown.scrollHeight}px`;
              }
            }

            dropdown.style.height = 0;
            dropdown.classList.remove('-active');
          } else {    
            // close active submenu
            let active_height = 0;
            if (submenu_active) {
              let dropdown_active = submenu_active.nextElementSibling;
              active_height = dropdown_active.scrollHeight;
  
              submenu_active.classList.remove('-active');
      
              dropdown_active.classList.remove('-active');
              dropdown_active.style.height = 0;
            }
  
            // open new submenu
            submenu.classList.add('-active');
            dropdown.style.height = `${dropdown.scrollHeight}px`;

            // fix parent height
            if (submenu.parentElement.classList.contains('-active')) {
              if (submenu.parentElement.parentElement.classList.contains('-active')) {
                submenu.parentElement.parentElement.style.height = `${submenu.parentElement.parentElement.scrollHeight - active_height}px`;
                submenu.parentElement.style.height = `${submenu.parentElement.scrollHeight + dropdown.scrollHeight}px`;
              } else {
                submenu.parentElement.style.height = `${submenu.parentElement.scrollHeight + dropdown.scrollHeight - active_height}px`;
              }
            }
            
            setTimeout(() => {
              dropdown.classList.add('-active');
            }, delay);
          }
          
          setTimeout(() => {
            _this.menu_mobile.classList.remove('-opening');
            _this.menu_overlay.classList.remove('-opening');
          }, delay);
        }
      });
    });
  },
  init: function () {
    this.open();
    this.close();
    this.submenus();
  }
}

export default MenuMobile;
